import fetch from "cross-fetch";
import { QueryParametersState } from "@idw-types/state";
import { APValidationTypes } from "@enums/ap-validation-types";

export const validateLiveness = (
    queryParameters: QueryParametersState,
    imageData: string,
    asi: string
) => {
    const body = {
        token: queryParameters.token,
        validationTypes: [APValidationTypes.LIVENESS],
        validationInputs: {
            cameraSnapshot: imageData
        },
        asi
    };

    const route = `${queryParameters.apiUrl}/axn/doc/validate`;
    const request = {
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body),
        method: "POST"
    };

    return fetch(route, request);
};